/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Conversations_Report_MissingInputs */



/**
* | output |
* | --- |
* | "Which conversations have no report yet?" |
*
* @param {Chat_Quick_Conversations_Report_MissingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_conversations_report_missing = /** @type {((inputs?: Chat_Quick_Conversations_Report_MissingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Conversations_Report_MissingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Van welke gesprekken staat het verslag nog niet klaar?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour quelles conversations le compte rendu n'est-il pas encore prêt ?")
	return /** @type {LocalizedString} */ ("Which conversations have no report yet?")
});